import styled from '@emotion/styled';
import { Colors } from '@utex/ui-kit';

export const Container = styled.nav`
  display: inline-flex;
  margin-bottom: 1rem;
  padding: 0.2rem;
  background-color: ${Colors.ut.inputDown};
  border-radius: 10rem;
`;
